module.exports = __webpack_public_path__ + "img/balanced-logo-white.ee4274d3.svg";